
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import "../css/TopNavbar.css";
import logoImg from '../img/logo.png';

export default function TopNavbar(props) {
  const [show, setShow] = useState(true);
  const lastScrollYRef = useRef(0);
  const [isMobile, setIsMobile] = useState(false);
  const [followingNew, setFollowingNew] = useState(false);
  const [followingLatestId, setFollowingLatestId] = useState(null);

  const updateMobileStatus = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  const checkFollowingNew = () => {
    const token = localStorage.getItem('jwt');
    if(!token){ setFollowingNew(false); return; }
    fetch('/myfollowingpost', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => { if (r.status === 401) { setFollowingNew(false); return null; } return r.json(); })
      .then(list => {
        if (!list) return;
        if (!Array.isArray(list) || list.length === 0) { setFollowingNew(false); return; }
        // determine newest post by createdAt timestamp (server may return unsorted)
        let latest = list[0];
        for (let i = 1; i < list.length; i++) {
          const a = new Date(latest.createdAt || latest.updatedAt || 0).getTime();
          const b = new Date(list[i].createdAt || list[i].updatedAt || 0).getTime();
          if (b > a) latest = list[i];
        }
        const latestId = latest._id;
        setFollowingLatestId(latestId);
        const lastSeen = localStorage.getItem('followingLastSeenId');
        if (!lastSeen) {
          // do not auto-mark as seen on page load; show badge until user explicitly clicks
          setFollowingNew(true);
        } else {
          setFollowingNew(latestId !== lastSeen);
        }
      }).catch(()=>{});
  }

  const controlNavbar = () => {
    if (window.scrollY > lastScrollYRef.current) {
      setShow(false);
    } else {
      setShow(true);
    }
    lastScrollYRef.current = window.scrollY;
  };

  useEffect(() => {
    updateMobileStatus(); // Initial check
    // initialize last scroll position to current window scroll so mount doesn't incorrectly hide navbar
    lastScrollYRef.current = window.scrollY || 0;
    setShow(true);
    window.addEventListener('resize', updateMobileStatus);
    window.addEventListener('scroll', controlNavbar);
    checkFollowingNew();
    window.addEventListener('user-changed', checkFollowingNew);

    return () => {
      window.removeEventListener('resize', updateMobileStatus);
      window.removeEventListener('scroll', controlNavbar);
      window.removeEventListener('user-changed', checkFollowingNew);
    };
  }, []);
  

  return (
    isMobile && (
      <div className={`top-navbar ${(props.forceHide ? false : show) ? 'show' : 'hide'}`}>
        <div className="top-row">
          <Link to="/" className="logo">
            <img src={logoImg} alt="Linkalikes" style={{height:40, display:'block', objectFit:'contain', width:'auto'}} />
          </Link>
          <ul className="nav-menu">
          {/* <Link to="/draw">
            <li>
              <span style={{ marginRight: "0px" }} className="material-symbols-outlined">brush</span>
            </li>
          </Link> */}
          <Link
            to="/followingpost"
            style={{ position: 'relative' }}
            onClick={() => {
              try{
                if(followingLatestId){
                  localStorage.setItem('followingLastSeenId', followingLatestId);
                } else {
                  localStorage.setItem('followingLastSeenId', '');
                }
              }catch(e){}
              setFollowingNew(false);
            }}
          >
            <li style={{ position: 'relative', display: 'inline-block' }}>
              <span style={{ marginRight: "5px" }} className="material-symbols-outlined">group</span>
              {followingNew && <span style={{background:'red',display:'inline-block',width:12,height:12,borderRadius:12,position:'absolute',top:-6,right:-6}}></span>}
            </li>
          </Link>
          <Link to="/search">
            <li>
              <span style={{ marginRight: "5px" }} className="material-symbols-outlined">travel_explore</span>
            </li>
          </Link>
          <Link to="/explore">
            <li>
              <span style={{ marginRight: "5px" }} className="material-symbols-outlined">explore</span>
            </li>
          </Link>
        </ul>
        </div>
        {/* optional filters inserted by parent (e.g., Home) */}
        {props.showFilters && (
          <div className="tn-filters">
            <input className="tn-input about-filter" placeholder="Search by About Post" value={props.aboutFilter || ''} onChange={e => props.setAboutFilter && props.setAboutFilter(e.target.value)} maxLength={128} />
            <input className="tn-input interest-filter" placeholder="Search by interest" value={props.interestFilter || ''} onChange={e => props.setInterestFilter && props.setInterestFilter(e.target.value)} maxLength={80} />
            <div className="tn-filter-actions">
              {/* <button onClick={props.applyFilters} className="tn-apply">Apply</button> */}
              {/* <button onClick={props.clearFilters} className="tn-clear">Clear</button> */}
            </div>
          </div>
        )}
      </div>
    )
  );
}

